<template>
  <div>
    <b-container class="transport pt-5">
      <div class="textOverSlider d-none d-md-block">
        <h1>
          FOR THOSE
          <br />WHO VALUE... <br />GO TRAIN &amp; <br />HIGHWAY ACCESS
        </h1>
        <p>
          Barrie South GO Train station is just down the street from MVP. Residents here can travel to Union Station in as little as 90 minutes, with regular
          train or bus service available 7 days a week. MVP is also located just minutes from Hwy. 400, providing rapid access to Toronto, Vaughan, Newmarket
          and cottage country.
        </p>
      </div>
      <b-row class>
        <b-col cols="12" offset="0" md="5" offset-md="1" lg="4" offset-lg="2" class="intro-text cstm-mb-80">
          <div id="carouselExample1" class="carousel slide" data-bs-ride="carousel">
            <!-- Indicator styling is in the index page -->
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselExample1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExample1" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselExample1" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="4000">
                <img src="/img/go-station.jpg" fluid class="d-block w-100" alt="go station" />
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/go-station-2.jpg" fluid class="d-block w-100" alt="go station 2" />
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/go-station-3.jpg" fluid class="d-block w-100" alt="go station 3" />
              </div>
            </div>
            <button class="carousel-control-prev visually-hidden" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next visually-hidden" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </b-col>
      </b-row>
      <div class="textOverSliderMobile d-md-none">
        <b-col cols="12">
          <h1>FOR THOSE WHO VALUE... GO TRAIN &amp; HIGHWAY ACCESS</h1>
          <p>
            Barrie South GO Train station is just down the street from MVP. Residents here can travel to Union Station in as little as 90 minutes, with regular
            train or bus service available 7 days a week. MVP is also located just minutes from Hwy. 400, providing rapid access to Toronto, Vaughan, Newmarket
            and cottage country.
          </p>
        </b-col>
      </div>
      <!-- <b-col md="2" offset-md="1" offset-lg="2" class="d-none d-sm-none d-md-block arrows">
        <b-row>
          <b-col @click="prev">
            &larr;
          </b-col>
          <b-col @click="next">
            &rarr;
          </b-col>
        </b-row>
      </b-col>-->
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      // transportSlick: {
      //   speed: 1000,
      //   autoplay: true,
      //   autoplaySpeed: 2500,
      //   slidesToShow: 1,
      //   arrows: false,
      //   dots: true
      // }
    };
  },
  mounted() {},
  methods: {
    next() {
      this.$refs.myCarousel.next();
    },
    prev() {
      this.$refs.myCarousel.prev();
    },
  },
};
</script>

<style lang="scss">
.transport {
  position: relative;
  .image-holder {
    img {
      width: 100%;
    }
  }
  .slick-arrow {
    background-color: red;
  }
  .textOverSlider {
    width: 65%;
    // color: white;
    color: #f05b2d;
    position: absolute;
    padding: 20px 10px 20px 28%;
    top: 20%;
    left: 25%;
    // background-color: #29AAE1;
    background-color: #f1f1f2;
    h1 {
      font-weight: normal;
      font-size: 40px;
    }
    p {
      font-size: 14px;
      // color: white;
      color: #231f20;
      padding-right: 40px;
    }
    @media screen and (min-width: 768px) and (max-width: 1200px) {
      h1 {
        font-size: 25px;
      }
    }
  }
  .textOverSliderMobile {
    margin-top: -120px;
    padding-top: 65px;
    padding-bottom: 25px;
    text-align: center;
    // color: white;
    color: #f05b2d;
    // background-color: #29AAE1;
    background-color: #f1f1f2;
    h1 {
      font-weight: normal;
      font-size: 25px;
    }
    p {
      font-size: 14px;
      // color: white;
      color: #231f20;
    }
  }
  .slick-dots {
    @media screen and (min-width: 768px) {
      right: -60px;
    }
  }
  .slick-dots li:before {
    background-color: #ffffff;
  }
  .slick-dots li.slick-active:before {
    background-color: #f05b2d;
  }
}
</style>
